// extracted by mini-css-extract-plugin
module.exports = {"origin":"Tooltip-origin-be0f","tooltip":"Tooltip-tooltip-be0f","top":"Tooltip-top-be0f","show":"Tooltip-show-be0f","default":"Tooltip-default-be0f"};